<div *ngIf="redirectLogin == false && authUserLogged() == false else tplheadercontainer">
    <app-loading></app-loading>
</div>
<ng-template #tplheadercontainer>
    <div id="loggedIn">
            <mat-grid-list cols="1" rowHeight="81px">
                <mat-grid-tile>
                    <app-header-container [showheader]="authUserLogged()" [initialTabindex]="1"></app-header-container>
                </mat-grid-tile>
            </mat-grid-list>
        
            <app-auth-frame></app-auth-frame>
            <app-language></app-language>
            <div *ngIf="isHomePage" class="disclaimer-container">
                <div class="disclaimer-content">
                    <p class="disclaimer-text">{{ 'DISCLAIMER' | translate }}</p>
                </div>
            </div>
            <app-footer [tabindex]="10"></app-footer>
        </div>
</ng-template>

<div *ngIf="!islogged" id="notLoggedIn">
    <app-error-login></app-error-login>
</div>
<app-page-guide></app-page-guide>
